// Ordinamento dei record DENTRO una fascia di priorità (banda 3 della pagina Priorità):
// prima la fibra del rame, le aziende prima dei privati, a parità il record più vecchio.
// Estratto in modulo puro (stesso schema di exportHubData.js) perché non è logica
// banale e va testata da sola, non solo osservata dentro il componente.
const TECH_RANK = { FTTH: 0, FTTC: 1, FWA: 2, ADSL: 2 };

export const techRank = (t) => (t in TECH_RANK ? TECH_RANK[t] : 3);
export const impresaRank = (t) => (t === 'azienda' ? 0 : 1);
// data d'ingresso nella fascia; fallback alla data di import per i record legacy
// senza export_motivo_at (mai dovrebbe capitare su chi ha già un export_motivo).
export const dataEntrata = (it) => (it && (it.export_motivo_at || it.imported_at)) || '';

export function comparaEntroFascia(a, b) {
  return (
    techRank(a.copertura_tecnologia) - techRank(b.copertura_tecnologia)
    || impresaRank(a.tipo_impresa) - impresaRank(b.tipo_impresa)
    || dataEntrata(a).localeCompare(dataEntrata(b))
  );
}

export function ordinaEntroFascia(items) {
  return [...(items || [])].sort(comparaEntroFascia);
}

// ── Territorio a tre livelli (banda 2 della pagina Priorità) ──────────────
// L'endpoint GET /esportabili/territorio (senza `provincia`) restituisce già una
// riga per provincia con `reg` (regione ISTAT). Le REGIONI si ottengono sommando
// quelle righe per `reg`, lato client: nessuna modifica al backend, e il totale
// resta coerente per costruzione con le tessere (stessa fonte dati).
const REGIONE_IGNOTA = 'Regione non mappata';

// Chiave di raggruppamento di una riga-provincia: le province senza mappatura
// (reg assente/vuota) finiscono sotto un'etichetta esplicita, non spariscono in
// silenzio — stesso principio del paracadute in righe_territorio sul backend.
export const regioneDi = (rigaProvincia) => (rigaProvincia && rigaProvincia.reg) || REGIONE_IGNOTA;

// Somma le righe-provincia per regione. Stessa forma {nome,p1,p2,p3,totale} delle
// righe-provincia, così la tabella del territorio renderizza regioni e province
// con lo stesso codice. Ordinata come il backend (righe_territorio): totale
// decrescente, a parità nome crescente. Pura.
export function aggregaRegioni(righeProvincia) {
  const perRegione = {};
  (righeProvincia || []).forEach((r) => {
    const nome = regioneDi(r);
    const acc = perRegione[nome] || (perRegione[nome] = { nome, p1: 0, p2: 0, p3: 0 });
    acc.p1 += r.p1 || 0;
    acc.p2 += r.p2 || 0;
    acc.p3 += r.p3 || 0;
  });
  const righe = Object.values(perRegione).map((r) => ({ ...r, totale: r.p1 + r.p2 + r.p3 }));
  righe.sort((a, b) => (b.totale - a.totale) || a.nome.localeCompare(b.nome, 'it'));
  return righe;
}

// Le province di una regione (stesso criterio di raggruppamento di aggregaRegioni),
// usate per espandere l'albero sotto la regione selezionata e — quando manca il
// filtro `provincia` per la lista dei record — per sapere quali province interrogare
// una alla volta (GET /esportabili/lista non conosce la regione). Pura.
export function provinceDiRegione(righeProvincia, regione) {
  return (righeProvincia || []).filter((r) => regioneDi(r) === regione);
}
